import * as React from 'react'

import { UpdateCyclePerformanceReviewProcessDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { CycleSelectField } from 'modules/performance_cycles/components/CycleSelectField'

export const CycleSelector: React.FC<{
  reviewId: number
  cycleId: string | null | undefined
  isDisabled: boolean
}> = ({ reviewId, cycleId, isDisabled }) => {
  const [updateCyclePerformanceReviewProcess, { loading }] = useMutation(
    UpdateCyclePerformanceReviewProcessDocument,
    {
      extractorFn: (data) => data.performanceMutations.updateCyclePerformanceReviewProcess,
    }
  )

  const updateCycle = async (newCycleId: string | null | undefined) => {
    const response = await updateCyclePerformanceReviewProcess({
      variables: {
        cycleId: newCycleId,
        id: reviewId,
      },
    })

    const result = handleResult(response, () => undefined)

    if (result.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('common.saved_successfully'),
      })
    }
  }

  return (
    <CycleSelectField
      value={cycleId}
      label={i18n.t('performance_process.reviews.basic_information_section.cycle_label')}
      blankLabel={i18n.t('performance_process.reviews.basic_information_section.cycle_blank_label')}
      placeholder={i18n.t(
        'performance_process.reviews.basic_information_section.cycle_placeholder'
      )}
      onChange={(newCycleId) => updateCycle(newCycleId)}
      isDisabled={loading || isDisabled}
    />
  )
}
